import PartyTarget from "../character/PartyTarget";
import { LayerDescriptionMap } from "../grid/LayerDescriptions";

export default class PartyTargetSave {
    constructor() {
    }

    /**
     * @param {PartyTarget} partyTarget 
     * @returns {Object}
     */
    static generateSave(partyTarget) {
        const saveState = {};

        saveState.layerId = partyTarget.layerDescription.id;
        saveState.targetMineSeconds = partyTarget.targetMineSeconds;

        return saveState;
    }

    /**
     * @param {PartyTarget} partyTarget 
     * @param {Object} saveState 
     */
    static loadSave(partyTarget, saveState) {
        if (!saveState) {
            return;
        }

        if (saveState.targetMineSeconds) {
            partyTarget.targetMineSeconds = saveState.targetMineSeconds;
        }

        const layerId = saveState.layerId;

        const layerDescription = LayerDescriptionMap[layerId];

        if (layerDescription) {
            partyTarget.setLayerDescriptionFromSave(layerDescription)
        }
        else {
            console.log('PartyTargetSave.loadSave() Failed to find layer description: ' + layerId);
        }
    }
}